import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    replaceCompaniesSelfOnboarding,
    fetchCompaniesSelfOnboarding,
} from '@perpay-web/fintech/actions/ui/companies';
import CompanySelfOnboard from '@perpay-web/fintech/components/composite/CompanySelfOnboard/CompanySelfOnboard';
import {
    getHasLoadedResults,
    getOtherCompany,
    getSelfOnboardingMatches,
    getIsLoadingResults,
    getError,
} from '@perpay-web/fintech/selectors/ui/companies';

/**
 * Container component for CompanySelfOnboard
 * @param {Object} props - Component props
 * @param {Function} [props.onSubmit] - Callback function for form submission
 * @param {string} [props.initialValue] - Initial value for the company name input
 * @param {Function} [props.children] - Render prop function for custom rendering
 * @returns {JSX.Element} CompanySelfOnboard component
 */
const CompanySelfOnboardContainer = ({
    onSubmit,
    initialValue = '',
    children,
}) => {
    const dispatch = useDispatch();

    const hasLoadedResults = useSelector(getHasLoadedResults);
    const otherCompany = useSelector(getOtherCompany);
    const selfOnboardingMatches = useSelector(getSelfOnboardingMatches);
    const isLoadingResults = useSelector(getIsLoadingResults);
    const error = useSelector(getError);

    const clearSelfOnboardingCompanyResults = useCallback(
        () => dispatch(replaceCompaniesSelfOnboarding({})),
        [dispatch],
    );

    const onSelfOnboardingOpen = useCallback(
        (value) => dispatch(fetchCompaniesSelfOnboarding(value)),
        [dispatch],
    );

    const onSelfOnboardingInput = useCallback(
        (value) => dispatch(fetchCompaniesSelfOnboarding(value)),
        [dispatch],
    );

    return (
        <CompanySelfOnboard
            error={error}
            hasLoadedResults={hasLoadedResults}
            onSubmit={onSubmit}
            initialValue={initialValue}
            otherCompany={otherCompany}
            selfOnboardingMatches={selfOnboardingMatches}
            isLoadingResults={isLoadingResults}
            clearSelfOnboardingCompanyResults={
                clearSelfOnboardingCompanyResults
            }
            onSelfOnboardingOpen={onSelfOnboardingOpen}
            onSelfOnboardingInput={onSelfOnboardingInput}
        >
            {children}
        </CompanySelfOnboard>
    );
};

export default CompanySelfOnboardContainer;
